import Service from "./Service";

const baseurl = '/api/ihce';

export default {
    /**
     * Envía una historia clínica al Ministerio de Salud (IHCE).
     * @param {number} id_historia_clinica - ID de la historia clínica
     * @returns {Promise}
     */
    enviarAlMinisterio(id_historia_clinica) {
        return Service.post(`${baseurl}/enviar-ministerio`, { id_historia_clinica });
    },
    /**
     * Consulta los encuentros clínicos de un paciente registrados ante el Ministerio de Salud (IHCE).
     * @param {Object} data - { documento_paciente, documento_usuario, tipo_documento_paciente }
     * @returns {Promise}
     */
    consultarEncuentros(data) {
        return Service.post(`${baseurl}/consultar-encuentros`, data);
    },
    /**
     * Consulta los RDAs de antecedentes del paciente registrados en el Ministerio de Salud (IHCE).
     * @param {Object} data - { documento_paciente, documento_usuario, tipo_documento_paciente, tipo_documento }
     * @returns {Promise}
     */
    consultarRdaPaciente(data) {
        return Service.post(`${baseurl}/consultar-rda-paciente`, data);
    },
    /**
     * Obtiene el documento clínico por su ID de Composition desde el Ministerio.
     * @param {string} id - ID de la Composition
     * @returns {Promise}
     */
    consultarDocumento(id) {
        return Service.get(`${baseurl}/consultar-documento/${id}`);
    },
    /**
     * Obtiene el documento clínico en formato PDF (Blob) desde el backend.
     * @param {string} id - ID de la Composition
     * @returns {Promise}
     */
    consultarDocumentoPDF(id) {
        return Service.get(`${baseurl}/consultar-documento-pdf/${id}`, { responseType: 'blob' });
    },
    /**
     * Obtiene el listado paginado de logs.
     * @param {Object} params - { page, status }
     * @returns {Promise}
     */
    getLogs(params = {}) {
        return Service.get(`${baseurl}/logs`, { params });
    },
    /**
     * Obtiene los detalles de un log específico.
     * @param {number|string} id - ID del log
     * @returns {Promise}
     */
    getLogDetails(id) {
        return Service.get(`${baseurl}/logs/${id}/details`);
    },
    /**
     * Reintenta el envío de un RDA fallido.
     * @param {number|string} id - ID del log
     * @returns {Promise}
     */
    retryLog(id) {
        return Service.post(`${baseurl}/logs/${id}/retry`);
    },
    /**
     * Reintenta el envío de TODOS los RDA fallidos.
     * @returns {Promise}
     */
    retryAllFailed() {
        return Service.post(`${baseurl}/logs/retry-all-failed`);
    }
};
